// Phase 13 — shared helpers for the money field screens
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useDistributors() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/distributors?page_size=200").then(r => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return items;
}

export function useRetailers() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/retailers?page_size=200").then(r => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return items;
}

export function useSkus() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/skus?page_size=500").then(r => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return items;
}

export async function compressAndUploadPhoto(file, maxDim = 800, quality = 0.6) {
  const img = document.createElement("img");
  const url = URL.createObjectURL(file);
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = url; });
  const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * scale);
  c.height = Math.round(img.height * scale);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  const blob = await new Promise((res) => c.toBlob(res, "image/jpeg", quality));
  URL.revokeObjectURL(url);
  const fd = new FormData();
  fd.append("file", blob, "photo.jpg");
  const { data } = await api.post("/photos/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.ref;
}

export function todayIsoDate() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function idempKey(prefix) {
  const rnd = (crypto.randomUUID?.() || Math.random().toString(36) + Date.now());
  return `${prefix}-${rnd}`.slice(0, 60);
}

export function useGps() {
  const [gps, setGps] = useState(null);
  useEffect(() => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (p) => setGps({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      () => {}, { enableHighAccuracy: true, timeout: 10000 }
    );
  }, []);
  return gps;
}

// map of status -> pill classes
export const statusClass = {
  submitted:          "bg-amber-50 text-amber-800 border-amber-200",
  verified:           "bg-emerald-50 text-emerald-800 border-emerald-200",
  approved:           "bg-emerald-50 text-emerald-800 border-emerald-200",
  asm_approved:       "bg-sky-50 text-sky-800 border-sky-200",
  accounts_approved:  "bg-emerald-50 text-emerald-800 border-emerald-200",
  paid:               "bg-emerald-100 text-emerald-900 border-emerald-300",
  discrepancy:        "bg-orange-50 text-orange-800 border-orange-200",
  rejected:           "bg-rose-50 text-rose-700 border-rose-200",
  asm_rejected:       "bg-rose-50 text-rose-700 border-rose-200",
  accounts_rejected:  "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusPill({ status }) {
  const cls = statusClass[status] || "bg-neutral-100 text-neutral-700 border-neutral-200";
  return <span className={`inline-block px-2 py-0.5 rounded text-[11px] border ${cls}`}>{status?.replace(/_/g, " ")}</span>;
}
